import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { renewToken } from '../../actions/authentication';
import { renewTokenSuccess } from '../../actions/login';
import * as LoginCode from '../../scripts/StatusLoginCode';
import * as cookie from '../../scripts/CookiesAppGo';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import LoadingOverlay from 'react-loading-overlay';
import BeatLoader from 'react-spinners/BeatLoader';
import { logout } from '../../actions/authentication';


class DialogTimeout extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            time: {},
            seconds: 30
        }

        this.timer = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);
    }

    resetTimer = () => {
        this.timer = 0;
        this.setState({ seconds: 30 });
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
    }

    secondsToTime = (secs) => {
        let hours = Math.floor(secs / (60 * 60));

        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);

        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    componentDidMount() {
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
        this.validateExpireToken();
    }

    startTimer = () => {
        if (this.timer == 0 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        }
    }

    countDown = () => {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });

        // Check if we're at zero.
        if (seconds == 0) {
            clearInterval(this.timer);
            this.logoutExpired();
        }
    }

    logoutExpired = () => {
        //window.location.href = '/login/1';
        logout(true);
    }

    validateExpireToken = () => {
        const { cookies } = this.props;

        let timeout = cookies.get(cookie.token_timeout) === 'true';

        if (timeout) {
            this.setState({ open: true });
            this.startTimer();
        }

        setInterval(() => {
            let timeout = cookies.get(cookie.token_timeout) === 'true';
            if (timeout === true) {
                this.setState({ open: true });
                this.startTimer();
            }
        }, 20000);
    }

    handleNo = () => {
        this.logoutExpired();
    }

    handleYes = () => {
        renewToken().then((result) => {
            const { cookies } = this.props;
            cookies.set(cookie.token_timeout, false, { path: '/' });
            cookies.set(cookie.login, new Date().toLocaleString(), { path: '/' });

            clearInterval(this.timer);
            this.resetTimer();

            if (result.statusLogin === LoginCode.LOGIN_SUCCESSFULL) {
                renewTokenSuccess(result.token);
            }
            else {
                //window.location.href = '/login';
                logout(true);
            }
            this.setState({ open: false });
        });
    }

    render() {
        return (
            <LoadingOverlay
                active={this.state.isActive}
                spinner={<BeatLoader />}
                text={i18next.t('punch:form.loading')}
            >
                <div>
                    <Dialog
                        open={this.state.open}
                        onClose={this.handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{i18next.t('token:validation.message.expire-title')}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {i18next.t('token:validation.message.expire-description')} {this.state.time.s} {i18next.t('token:validation.message.expire-seconds')}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button className={'btn-default'} onClick={this.handleNo}>
                                {i18next.t('token:validation.dialog.no')}
                            </Button>
                            <Button className={'btn-default'} onClick={this.handleYes} autoFocus>
                                {i18next.t('token:validation.dialog.yes')}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </LoadingOverlay>
        );
    }
}

export default withNamespaces(['token', 'punch'], { wait: true })(DialogTimeout);